import React from 'react';
import { Button, ButtonColor, ButtonVariant, FormTemplate, IconType, TextInput } from 'ui-builder';
import {
  CreateWebhookSubscriptionRequest,
  useWebhookSubscriptionsService,
  WebhookSubscription
} from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';
import { SubscriptionEventDropdown } from './SubscriptionEventDropdown';

export function CreateWebhookSubscriptionForm(props: { afterSubmitFunc?: () => void }) {
  const webhookSubscriptionsService = useWebhookSubscriptionsService();

  return (
    <FormTemplate<CreateWebhookSubscriptionRequest, WebhookSubscription>
      title="Add New Webhook Subscription"
      submitFormFunc={async (data) => {
        const result = await webhookSubscriptionsService.createSubscription(data);
        if (props.afterSubmitFunc) {
          props.afterSubmitFunc();
        }
        return result;
      }}
      validationSchema={{
        webhookUrl: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
        eventType: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
    >
      <SubscriptionEventDropdown source="eventType" label="Event Type" />
      <TextInput source="webhookUrl" label="Webhook URL" />
    </FormTemplate>
  );
}

export function CreateWebhookSubscriptionButton() {
  const popupFormManager = usePopupFormManager();

  return (
    <Button
      text="Add Webhook"
      onClick={() => popupFormManager.openForm(<CreateWebhookSubscriptionForm />)}
      color={ButtonColor.BLUE}
      iconType={IconType.PLUS}
      variant={ButtonVariant.FILLED}
    />
  );
}
